import { atom } from "recoil";

const photoState =atom({
    key: 'photo',
    default: false
})

export default photoState